<!--  -->
<template>
  <div class="a">
    <component :is="currentComponent" />
  </div>
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import {
  defineComponent,
  ref,
  watch,
  onBeforeMount,
  onMounted,
  computed
} from "vue";
import Detail from "./Detail";
import List from "./List";
import { useRouter, useRoute } from "vue-router";
// 导入的其他文件 例如：import moduleName from 'modulePath';

export default defineComponent({
  components: {
    Detail,
    List
  },
  setup() {
    const currentComponent = ref("list");
    const router = useRouter();
    const route = useRoute();
    const routeQuery = computed(() => {
      const { query } = route;
      return query;
    });
    watch([routeQuery], ([newRouteQuery, preRouteQuery]) => {
      currentComponent.value = newRouteQuery.id ? "detail" : "list";
    });
    onBeforeMount(() => {});
    onMounted(() => {
      currentComponent.value = routeQuery.value.id ? "detail" : "list";
    });
    return {
      currentComponent
    };
  }
});
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.message-container {
  // @include flex(column, normal, normal);
  background-color: #f2f7ff;
  height: calc(100vh - 84px);
}
</style>